export default __webpack_public_path__ + "static/media/icon-note.5a3a8cb6.svg";